(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ridgetech-ac-compressor-mount"]) return;
  try {
    
(() => {
  const initializeViewers = () => document.querySelectorAll('[data-spin-viewer]').forEach((viewer) => {
    if (viewer.dataset.viewerReady === 'true') return;
    viewer.dataset.viewerReady = 'true';
    const image = viewer.querySelector('[data-spin-image]');
    const buttons = [...viewer.querySelectorAll('[data-spin-src]')];
    const previous = viewer.querySelector('[data-spin-prev]');
    const next = viewer.querySelector('[data-spin-next]');
    const counter = viewer.querySelector('[data-spin-count]');
    const zoomButtons = [...viewer.querySelectorAll('[data-photo-zoom]')];
    const modal = viewer.querySelector('[data-photo-modal]');
    const modalImage = viewer.querySelector('[data-modal-image]');
    const modalClose = viewer.querySelector('[data-modal-close]');
    const modalPrevious = viewer.querySelector('[data-modal-prev]');
    const modalNext = viewer.querySelector('[data-modal-next]');
    let active = 0;
    const show = (index) => {
      active = (index + buttons.length) % buttons.length;
      const button = buttons[active];
      viewer.classList.add('is-changing');
      window.setTimeout(() => {
        image.src = button.dataset.spinSrc;
        image.alt = button.dataset.spinAlt;
        if (modalImage) { modalImage.src = button.dataset.spinSrc; modalImage.alt = button.dataset.spinAlt; }
        buttons.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === active));
        if (counter) counter.textContent = `${active + 1} / ${buttons.length}`;
        viewer.classList.remove('is-changing');
      }, 120);
    };
    buttons.forEach((button, index) => button.addEventListener('click', () => show(index)));
    previous?.addEventListener('click', () => show(active - 1));
    next?.addEventListener('click', () => show(active + 1));
    zoomButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (!modal || typeof modal.showModal !== 'function') return;
        if (modalImage) {
          modalImage.src = image.currentSrc || image.src;
          modalImage.alt = image.alt;
        }
        modal.showModal();
      });
    });
    modalClose?.addEventListener('click', () => modal?.close());
    modalPrevious?.addEventListener('click', () => show(active - 1));
    modalNext?.addEventListener('click', () => show(active + 1));
    modal?.addEventListener('click', (event) => { if (event.target === modal) modal.close(); });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeViewers, { once: true });
  } else {
    initializeViewers();
  }
  document.addEventListener('shopify:section:load', initializeViewers);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ridgetech-contact"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initializeContactPage = () => {
    const form = document.querySelector('#RidgetechContactForm');
    if (form && form.dataset.ready !== 'true') {
      form.dataset.ready = 'true';
      const button = form.querySelector('[data-submit-button]');
      const label = form.querySelector('[data-submit-label]');
      form.addEventListener('submit', () => {
        if (!form.checkValidity() || !button || !label) return;
        button.disabled = true;
        label.textContent = 'Sending…';
      });
    }
    const thankYou = document.querySelector('[data-contact-success]');
    if (thankYou) {
      document.body.classList.add('rt-contact-submitted');
      window.location.replace('/pages/thank-you');
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeContactPage, { once: true });
  else initializeContactPage();
  document.addEventListener('shopify:section:load', initializeContactPage);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ridgetech-home-v2"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.rd .mobile-nav').forEach((menu) => {
    const trigger = menu.querySelector('summary');
    const update = () => {
      trigger?.setAttribute('aria-expanded', String(menu.open));
      trigger?.setAttribute('aria-label', `${menu.open ? 'Close' : 'Open'} the primary navigation`);
    };
    update();
    menu.addEventListener('toggle', update);
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      menu.removeAttribute('open');
      update();
    }));
    document.addEventListener('click', (event) => {
      if (menu.open && !menu.contains(event.target)) {
        menu.removeAttribute('open');
        update();
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) {
        menu.removeAttribute('open');
        update();
        trigger?.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
